import { useCallback, useState } from 'react'

export default (defaultValue) => {
    const [value, setValue] = useState(!!defaultValue)
  
    const setTrue = useCallback(() => setValue(true), [])
    const setFalse = useCallback(() => setValue(false), [])
  
    return [value, setValue, setTrue, setFalse ];
}